import { ICalculationItem } from 'components/calculation/CalculationContacts';

export const calcItemsCBK: ICalculationItem[][] = [
  [
    {
      title: 'Ишлейский проезд, д.&nbsp;11',
      times: ['<b>08:00 — 19:00</b>, Пн-Пт', '<b>09:00 — 19:00</b>, Сб-Вс'],
    },
  ],
];
